var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-message"},[_c('div',[_c('van-icon',{attrs:{"name":"success","color":"green"}})],1),_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }